import React from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import Features from './components/Features';
import HowItWorks from './components/HowItWorks';
import Newsletter from './components/Newsletter';
import Footer from './components/Footer';
import HeadManager from './components/HeadManager';
import './App.css';
import Manager from './pages/Manager';
import SignIn from './pages/SignIn';
import SignUp from './pages/SignUp';
import AccountRecovery from './pages/AccountRecovery';
import PassRecovery from './pages/PassRecovery';
import ResetPassword from './pages/ResetPassword';
import Feed from './pages/Feed';
import Profiles from './pages/Profiles';
import Assinantes from './pages/Assinantes';
import GestaoDizimos from './pages/GestaoDizimos';
import Missoes from './pages/Missoes';
import MissaoCaminhoDosSantos from './pages/MissaoCaminhoDosSantos';
import Devocional from './pages/Devocional';

const App: React.FC = () => {
  const gtmScript = {
    content: `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','GTM-TGZ3X25C');`,
    id: 'google-tag-manager'
  };

  return (
    <HeadManager
      title="SantoGram - Descubra seu Santo do Dia"
      description="Receba diariamente mensagens inspiradoras dos santos católicos. Uma jornada espiritual diária com SantoGram."
      keywords="santo do dia, santos católicos, mensagens espirituais, catolicismo, espiritualidade"
      author="SantoGram"
      ogTitle="SantoGram - Seu Santo do Dia"
      ogDescription="Descubra mensagens diárias dos santos católicos e enriqueça sua jornada espiritual."
      ogImage="/santo_do_dia.png"
      ogType="website"
      twitterCard="summary_large_image"
      twitterTitle="SantoGram - Seu Santo do Dia"
      twitterDescription="Mensagens espirituais diárias dos santos católicos"
      twitterImage="/santo_do_dia.png"
      favicon="/santogram_logo.png?v=2"
      scripts={[gtmScript]}
    >
      <div className="App">
        {/* Do not render global Header and Footer on auth and manager routes */}
        {!(['/manager', '/signin', '/signup', '/account-recovery', '/pass-recovery', '/reset-password', '/feed', '/profiles', '/assinantes', '/dizimos', '/missoes', '/missao', '/devocional'].includes(window.location.pathname)) && <Header />}

        <main>
          {/* Simple route handling based on window.location.pathname so we don't add new deps */}
          {window.location.pathname === '/manager' ? (
            <Manager />
          ) : window.location.pathname === '/signin' ? (
            <SignIn />
          ) : window.location.pathname === '/signup' ? (
            <SignUp />
          ) : window.location.pathname === '/account-recovery' ? (
            <AccountRecovery />
          ) : window.location.pathname === '/pass-recovery' ? (
            <PassRecovery />
          ) : window.location.pathname === '/reset-password' ? (
            <ResetPassword />
          ) : window.location.pathname === '/feed' ? (
            <Feed />
          ) : window.location.pathname === '/profiles' ? (
            <Profiles />
          ) : window.location.pathname === '/assinantes' ? (
            <Assinantes />
          ) : window.location.pathname === '/dizimos' ? (
            <GestaoDizimos />
          ) : window.location.pathname === '/missao' ? (
            <MissaoCaminhoDosSantos />
          ) : window.location.pathname === '/devocional' ? (
            <Devocional />
          ) : window.location.pathname === '/missoes' ? (
            <Missoes />
          ) : (
            <>
              <Hero />
              <Features />
              <HowItWorks />
              <Newsletter />
            </>
          )}
        </main>

        {!(['/signin', '/signup', '/account-recovery', '/pass-recovery', '/reset-password', '/feed', '/profiles', '/assinantes', '/dizimos', '/missoes', '/missao', '/devocional'].includes(window.location.pathname)) && <Footer />}
      </div>
    </HeadManager>
  );
};

export default App;
